import(/* webpackMode: "eager" */ "/usr/app/src/app/not-found.tsx");
